export default {
    init() {
      // JavaScript to be fired on the lign page
        var num = Math.floor(Math.random() * 5) + 1;    
        console.log(num);    

        $('.login .full-bg-img').addClass('bg-image-' + num);
      
    },
    finalize() {
      // JavaScript to be fired on the login page, after the init JS
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/login.js